import {
  GenerateInvoiceDto,
  Invoice,
  InvoiceSellerInformation,
} from "./dto/generate-invoice.dto";
import { createUseApi } from "./useApi";
const config = useRuntimeConfig();
export const invoice = {
  useGenerateInvoice: createUseApi<[string, GenerateInvoiceDto], void>({
    url: `${config.public.url}/invoice`,
    method: "POST",
    dataBuilder: (input) => ({
      email: input[0],
      data: input[1],
    }),
  }),
  useCreateInvoice: createUseApi<GenerateInvoiceDto, void>({
    url: `${config.public.url}/invoice/my`,
    method: "POST",
    dataBuilder: (input) => ({
      data: input,
    }),
    requireAuthentication: true,
  }),
  useDeleteInvoice: createUseApi<string, void>({
    method: "DELETE",
    url: (input) => {
      return `${config.public.url}/invoice/${input}`;
    },
    requireAuthentication: true,
  }),
  useGetAllInvoices: createUseApi<
    {
      page: number;
      invoiceFilter: string;
    },
    {
      meta: {
        total: number;
      };
      data: Invoice[];
    }
  >({
    method: "GET",
    url: `${config.public.url}/invoice`,
    queryBuilder: (input) => {
      return {
        page: input.page,
        limit: 7,
        prompt: input.invoiceFilter,
      };
    },
    requireAuthentication: true,
  }),
  useGetOneInvoice: createUseApi<string, Invoice>({
    method: "GET",
    url: (input) => {
      return `${config.public.url}/invoice/${input}`;
    },
    requireAuthentication: true,
  }),
  useEditInvoice: createUseApi<[string, GenerateInvoiceDto], void>({
    method: "PATCH",
    url: (input) => {
      return `${config.public.url}/invoice/${input[0]}`;
    },
    dataBuilder: (input) => ({
      data: input[1],
    }),
    requireAuthentication: true,
  }),
  useDownloadInvoice: createUseApi<string, Blob>({
    method: "GET",
    url: (input) => `${config.public.url}/invoice/${input}/download`,
    requireAuthentication: true,
  }),

  useLoadSellerInfo: createUseApi<void, InvoiceSellerInformation>({
    method: "GET",
    url: `${config.public.url}/user/seller-info`,
    requireAuthentication: true,
  }),

  useUpdateSellerInfo: createUseApi<InvoiceSellerInformation, void>({
    method: "PUT",
    url: `${config.public.url}/user`,
    requireAuthentication: true,
    dataBuilder: (inputData) => {
      return { sellerInformation: JSON.stringify(inputData) };
    },
  }),
};
